export const MILES_LIST = 'MILES_LIST'
export const MILES_LIST_SUCCESS = 'MILES_LIST_SUCCESS'
